import axios from 'axios';

import { POST_ANSWER } from '../../../settings/endpoint';

export const taskPreview = ({ history, state, dispatch }) => {
  axios
    .post(POST_ANSWER(history.location.pathname.slice(6)), {
      question: state.question.id,
      user_answer: state.question.question_variety,
    })
    .then(res => {
      dispatch({ type: 'setSelectAnswer', payload: '' });
      dispatch({ type: 'getLink', payload: res.data.link });
      dispatch({
        type: 'getQuestionCount',
        payload: {
          question_number: res.data.question_scale.question_number,
          questions_total: res.data.question_scale.questions_total,
        },
      });

      if (res.data.question !== undefined) {
        dispatch({ type: 'getQuestion', payload: { ...res.data.question, direction_title: res.data.survey_title } });
        dispatch({ type: 'setAnswerId', payload: res.data.answer_id });
      }

      dispatch({ type: 'setPending', payload: false });

      return null;
    })
    .catch(err => {
      dispatch({ type: 'setError' });
      dispatch({ type: 'setPending', payload: false });

      return new Error(err);
    });
};